export const SLOTS_BY_MEALS = {
  3: ["breakfast", "lunch", "dinner"],
  4: ["breakfast", "lunch", "snack", "dinner"],
  5: ["breakfast", "snack", "lunch", "snack2", "dinner"],
};
export const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const slotCategory = (slot) => (slot.startsWith("snack") ? "snack" : slot);
export const slotRatio = (slot) => (slot.startsWith("snack") ? 0.5 : 1);
export const slotLabelKey = (slot) => (slot === "snack2" ? "dm_snack2" : `demo_${slot}`);

// Même logique que meal_planner._matches_diet (étiquettes des recettes)
export function matchesDiet(recipe, diet) {
  const tags = recipe.tags || [];
  if (diet === "vegan") return tags.includes("vegan");
  if (diet === "vegetarian") return tags.includes("vegetarian") || tags.includes("vegan");
  if (diet === "pescatarian") return tags.includes("vegetarian") || tags.includes("vegan") || tags.includes("pescatarian");
  return true;
}

export const isCompatible = (recipe, allergies, diet) =>
  !(recipe.allergens || []).some((a) => allergies.includes(a)) && matchesDiet(recipe, diet);

export const formatQty = (qty) => {
  const r = Math.round(qty * 100) / 100;
  return Number.isInteger(r) ? String(r) : r.toFixed(r * 10 === Math.round(r * 10) ? 1 : 2).replace(".", ",");
};

// Liste de courses : uniquement les repas choisis, quantités × portions, 1 ligne par ingrédient
export function buildGrocery(plan, recipesById, days, slots, persons = 1) {
  const totals = {};
  let meals = 0;
  for (const day of days) {
    for (const slot of slots) {
      const r = recipesById[plan[day]?.[slot]];
      if (!r) continue;
      meals += 1;
      const ratio = slotRatio(slot) * persons;
      for (const ing of r.ingredients || []) {
        if (ing.qty == null) continue;
        const cur = totals[ing.key] || { key: ing.key, name: ing.name, unit: ing.unit, qty: 0 };
        cur.qty += ing.qty * ratio;
        totals[ing.key] = cur;
      }
    }
  }
  const items = Object.values(totals).map((i) => ({ ...i, qty: ["g", "ml"].includes(i.unit) ? Math.round(i.qty) : Math.round(i.qty * 4) / 4 }));
  return { meals, items };
}

const KEY = "chenia_demo_plan_v2";
export const loadDemoPlan = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };
export const saveDemoPlan = (plan) => localStorage.setItem(KEY, JSON.stringify(plan));

const SETTINGS_KEY = "chenia_demo_settings_v1";
export const loadDemoSettings = () => { try { return JSON.parse(localStorage.getItem(SETTINGS_KEY)) || {}; } catch { return {}; } };
export const saveDemoSettings = (s) => localStorage.setItem(SETTINGS_KEY, JSON.stringify(s));
export const clearDemoSettings = () => localStorage.removeItem(SETTINGS_KEY);

// Retire du menu les recettes devenues incompatibles (allergène coché, régime) ; renvoie [plan, nbRetirés]
export function prunePlan(plan, compatibleById) {
  let removed = 0;
  const next = {};
  for (const [day, slots] of Object.entries(plan)) {
    next[day] = {};
    for (const [slot, id] of Object.entries(slots || {})) {
      if (compatibleById[id]) next[day][slot] = id; else removed += 1;
    }
  }
  return [removed ? next : plan, removed];
}

const DAY_FULL = { mon: "monday", tue: "tuesday", wed: "wednesday", thu: "thursday", fri: "friday", sat: "saturday", sun: "sunday" };
// Choix de la semaine d'essai au format du programme ({day, slot, recipe_id}) pour reprise après création du compte
export function demoChoices() {
  const plan = loadDemoPlan();
  const out = [];
  for (const [day, slots] of Object.entries(plan)) {
    for (const [slot, id] of Object.entries(slots || {})) if (id && DAY_FULL[day]) out.push({ day: DAY_FULL[day], slot, recipe_id: id });
  }
  return out;
}
export const clearDemoPlan = () => localStorage.removeItem(KEY);
